import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ea14188&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea14188')) {
      api.createRecord('6ea14188', component.options)
    } else {
      api.reload('6ea14188', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ea14188&", function () {
      api.rerender('6ea14188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/hot/index.vue"
export default component.exports